var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observe, makeObservable } from 'mobx';
import { runtime } from '../../../runtime/Runtime';
export class EventorTriggerHoverTime {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        runtime.runtimeScheduler.addToNextIdleStateChange(() => (this.observer = observe(this, 'hoverTimeReachedAts', this.nodesDidChange)));
    }
    observer;
    get app() {
        return this.parent.app;
    }
    get onHoverTimeAts() {
        // return this.app.importingTree.attachedTraitsOfKey('onHoverTime' as any) as AttachedActionTrait[];
        return this.app.stage.stageAttachedTraits.allActiveTraitsOfKey('onHoverTime');
    }
    get hoverTimeReachedAts() {
        return this.onHoverTimeAts.filter(at => at.aspect.aspectInteract.isAspectHovering &&
            at.aspect.aspectInteract.timedInteract.hoverTime > at.valueOf.timespanInMilliseconds);
    }
    nodesDidChange({ oldValue, newValue }) {
        const added = newValue.filter(x => !oldValue.includes(x));
        // const removed = oldValue.filter(x => !newValue.includes(x));
        this.notifyBecomeActive(added);
        // this.notifyBecomeInActive(removed);
    }
    notifyBecomeActive(added) {
        added.forEach(at => {
            at.fireEvent();
        });
    }
}
__decorate([
    computed
], EventorTriggerHoverTime.prototype, "hoverTimeReachedAts", null);
__decorate([
    action.bound
], EventorTriggerHoverTime.prototype, "nodesDidChange", null);
__decorate([
    action.bound
], EventorTriggerHoverTime.prototype, "notifyBecomeActive", null);
